module.exports = __webpack_public_path__ + "static/img/radio.7b6c1394.png";